import React from 'react';

import {
  useCreate,
  useUpdate,
  useConceptFamily,
  useIsUpdating,
} from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';

import ConceptFamilyForm from './ConceptFamilyForm';
import { createValidationSchema, editValidationSchema } from './schemas';

export const CreateConceptFamilyForm = ({
  initialValues = {},
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [create] = useCreate();
  const isUpdating = useIsUpdating();
  const handleSubmit = async (values) => {
    const response = await create(values);
    onSubmit(response);
  };

  return (
    <ConceptFamilyForm
      loading={isUpdating}
      title={'Add Concept Family'}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      validationSchema={createValidationSchema}
    />
  );
};

export const EditConceptFamilyForm = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading } = useConceptFamily({ id });
  const [update, { isLoading: isUpdating }] = useUpdate();

  const handleSubmit = async (values) => {
    const createConceptFamilyId = await update(values);
    onSubmit({ id: createConceptFamilyId });
  };

  return (
    <ConceptFamilyForm
      loading={isLoading || isUpdating}
      title={'Edit Concept Family'}
      onClose={onClose}
      active={!!data}
      initialValues={data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      validationSchema={editValidationSchema}
      entityId={id}
    />
  );
};
